<template lang="pug">
v-progress-linear.BasePageLoadingProgress.page-loading-progress(
  height="3",
  color="#90be6d",
  top,
  :value="progress",
  v-show="isShow",
)
</template>

<script>
import {
  VProgressLinear,
} from 'vuetify/lib';
import { getRandomNumber } from 'Utils/numbers';

export default {
  name: 'BasePageLoadingProgress',
  components: {
    VProgressLinear,
  },
  props: {
    value: Boolean,
  },
  data() {
    return {
      progress: 34,
      isShow: false,
    };
  },
  watch: {
    value: {
      handler: 'changeHandler',
      immediate: true,
    },
  },
  methods: {
    changeHandler() {
      // Show progress bar only after 100ms
      setTimeout(() => {
        if (this.value) {
          this.setShow();
        } else {
          this.setHide();
        }
      }, 100);
    },
    setShow() {
      this.isShow = true;
      // Timeout to show initial animation
      this.showTimeoutId = setTimeout(() => {
        this.progress = 30;
        this.setProgress();
      }, 50);
    },
    setHide() {
      // Clear all timeouts
      clearTimeout(this.showTimeoutId);
      clearTimeout(this.progressTimeoutId);
      // Set progress to full
      this.progress = 100;
      // after animation
      setTimeout(() => {
        // hide progress bar
        this.isShow = false;
        // and reset progress
        this.progress = 0;
      }, 300);
    },
    setProgress() {
      this.progressTimeoutId = setTimeout(() => {
        this.progress += getRandomNumber(0.5, 3, 0.5) / (100 / (100 - this.progress));
        this.setProgress();
      }, getRandomNumber(150, 450, 50));
    },
  },
};
</script>

<style lang="sass" scoped>
.page-loading-progress
  margin: 0
  transform: scale(1, -1)
  position: fixed
  z-index: 998
</style>
